module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"my-page":"My Page","sales":"Sales","customers":"Customers","common-templates":"Common templates","logout":"Logout"},"ja":{"my-page":"マイページ","sales":"営業担当者","customers":"顧客情報","common-templates":"共通定型文設定","logout":"ログアウト"}}')
  delete Component.options._Ctor
}
